import styled from '@emotion/styled';
import { variant } from 'styled-system';

import sx from '../../internal/styles/sx';
import BaseText from '../BaseText';
import type { BodyProps } from './types';

const Body = styled(BaseText)<BodyProps>(
  variant({
    prop: 'weight',
    variants: {
      normal: {
        fontWeight: 'normal',
      },
      medium: {
        fontWeight: 'medium',
      },
      bold: {
        fontWeight: 'bold',
      },
    },
  }),
  variant({
    prop: 'type',
    variants: {
      base: {
        fontSize: 'bodies.base',
        lineHeight: 'bodies.base',
      },
      small: {
        fontSize: 'bodies.small',
        lineHeight: 'bodies.small',
      },
      xSmall: {
        fontSize: 'bodies.xSmall',
        lineHeight: 'bodies.xSmall',
      },
      xxSmall: {
        fontSize: 'bodies.xxSmall',
        lineHeight: 'bodies.xxSmall',
      },
    },
  }),
  ({ inline }) => (inline ? { display: 'inline' } : { display: 'block' }),
  sx
);

export default Body;
